// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__m8U4a","legacyBtn":"MutateMid_legacyBtn__Noapx"};